import React from 'react';
import {observer} from 'mobx-react';
import VolumeRateCoverageForm from './VolumeRateCoverageForm';
import ExperienceRatedCoverageForm from './ExperienceRatedCoverageForm';
import CostCoverageForm from './CostCoverageForm';

const CoverageFormFactory = observer(({uiState}) => {
  const {currentCoverage} = uiState;

  switch (currentCoverage.coverageCategory) {
    case 'volume_rate_coverage':
      return <VolumeRateCoverageForm uiState={uiState}/>;
    case 'experience_rated_coverage':
      return <ExperienceRatedCoverageForm uiState={uiState}/>;
    case 'cost_coverage':
      return <CostCoverageForm uiState={uiState}/>;
    case 'optional_coverage':
      return null;
    case 'excluded_coverage':
      return null;
    default: 
      throw new Error(`Unknown coverage category of ${currentCoverage.coverageCategory}`);
  }
});

export default CoverageFormFactory;
